/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import styled from '@emotion/styled';

import MeterCardContainer from '../components/MeterCardContainer';
import KioskModel from '../components/KioskModel';
import EnergyUtilityMeterDetail from './subsections/EnergyUtilityMeterDetail';
import { setCurrentGX } from '../actions';
import { connect } from 'react-redux';
import WithRouter from '../utilities/WithRouter';

import EnergyIcon from '../components/icons/EnergyIcon';

require('highcharts/modules/accessibility');
require('highcharts/modules/draggable-points');
require('highcharts/modules/exporting');
require('highcharts/modules/export-data');

const Energy = ({
  currentCampusData,
  currentCampusId,
  currentBuildingId,
  currentGXId,
  hasSingleGX,
  currentGXData,
  onBuildingChange,
  onGXChange,
  onZoneChange,
  router,
  updateGXData,
  showMobile,
  activePage,
}) => {
  let currentSelectedMeterData;
  let stateObj;
  let gxParam = router.location.pathname.split('/')[3];

  useEffect(() => {
    replaceUrl();
  }, [updateGXData]);

  //Call energy API when campus change
  useEffect(() => {
    updateGXData();
  }, [currentCampusId]);

  //When gx data updates, clear graphs and reload
  useEffect(() => {
    if (
      currentGXData?.gridInterconnects?.length === 1 &&
      currentGXId !==
        currentGXData.gridInterconnects[0].gridInterconnectDescription.gridInterconnectEntityKey
    ) {
      onGXChange(
        currentGXData.gridInterconnects[0].gridInterconnectDescription.gridInterconnectEntityKey
      );
    }

    //Graph data update every 5 seconds
    let interval = setInterval(() => {
      updateGXData();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentGXData]);

  function replaceUrl() {
    if (hasSingleGX && (gxParam === undefined || gxParam !== currentGXId) && currentGXId !== null) {
      window.history.replaceState(stateObj, '', router.location.pathname + `/${currentGXId}`);
    }
  }

  const navigateWithValidation = (newPath) => {
    if (router.location.pathname !== newPath) {
      router.navigate(newPath);
    }
  };

  const handleMeterSelect = (selectedMeter) => {
    onGXChange(selectedMeter);
    navigateWithValidation('/energy/' + currentCampusId + '/' + selectedMeter);
  };

  return (
    <EnergySection className={showMobile ? 'energy-section mobile' : 'energy-section desktop'}>
      {currentCampusData && currentGXData && (!currentGXId || hasSingleGX) ? (
        <>
          <div className={showMobile ? 'header-container mobile' : 'header-container'}>
            <div className="header">
              <EnergyIcon
                backgroundFill={'none'}
                fillColor={'#02222B'}
                strokeColor={'#02222B'}
                strokeWidth={2}
                width="18px"
              />
              <h1>Energy</h1>
            </div>
          </div>

          {currentGXData.gridInterconnects ? (
            <>
              {currentGXData.gridInterconnects?.map((gx) => (
                <div
                  className="meter-row"
                  key={`${gx.gridInterconnectDescription.gridInterconnectEntityKey}-meter-container`}
                >
                  <div className="meter-name-container">
                    <div className="meter-name">
                      {gx.gridInterconnectDescription.longGridInterconnectDisplayName
                        ? gx.gridInterconnectDescription.longGridInterconnectDisplayName
                        : 'Utility Meter'}
                    </div>

                    {currentGXData?.gridInterconnects.length > 1 && (
                      <button
                        className="meter-button"
                        onClick={() =>
                          handleMeterSelect(
                            gx.gridInterconnectDescription.gridInterconnectEntityKey
                          )
                        }
                      >
                        View Meter
                      </button>
                    )}
                  </div>

                  <div className={showMobile ? 'meter-container mobile' : 'meter-container'}>
                    {showMobile && (
                      <>
                        <MeterCardContainer
                          currentMeterData={currentSelectedMeterData}
                          gridPower={gx.kiosk.gridkW}
                          solarPower={gx.kiosk.solarkW}
                          batteryPower={gx.kiosk.batterykW}
                          batterySoc={gx.kiosk.batterySoc}
                          batterySockWh={gx.kiosk.batterySockWh}
                          hasSolar={gx.kiosk.hasSolar}
                          hasBattery={gx.kiosk.hasBattery}
                          hasEv={gx.kiosk.hasEvCharger}
                          evPower={gx.kiosk.evChargerkW}
                          hvacPower={gx.kiosk.hvackW}
                          otherPower={gx.kiosk.buildingkW}
                        />
                      </>
                    )}

                    <KioskModel
                      gxPower={gx.kiosk.gridkW}
                      hasSolar={gx.kiosk.hasSolar}
                      solarPower={gx.kiosk.solarkW}
                      hasBattery={gx.kiosk.hasBattery}
                      batteryDisplaySoc={gx.kiosk.batteryDisplaySoc}
                      batterySoc={gx.kiosk.batterySoc}
                      batteryPower={gx.kiosk.batterykW}
                      batterySockWh={gx.kiosk.batterySockWh}
                      hasEv={gx.kiosk.hasEvCharger}
                      hasEvConnected={gx.kiosk.hasEvConnected}
                      evPower={gx.kiosk.evChargerkW}
                      hvacPower={gx.kiosk.hvackW}
                      otherPower={gx.kiosk.buildingkW}
                    />
                  </div>

                  {hasSingleGX && (
                    <EnergyUtilityMeterDetail
                      currentCampusData={currentCampusData}
                      currentCampusId={currentCampusId}
                      currentBuildingId={currentBuildingId}
                      currentZoneId={null}
                      currentGXId={currentGXId}
                      hasSingleGX={hasSingleGX}
                      currentGXData={currentGXData}
                      onBuildingChange={onBuildingChange}
                      onGXChange={onGXChange}
                      onZoneChange={onZoneChange}
                      activePage={activePage}
                      showMobile={showMobile}
                    />
                  )}
                </div>
              ))}
            </>
          ) : (
            <div className="energy-empty-state">
              <EnergyIcon
                backgroundFill={'none'}
                fillColor={'#02222B'}
                strokeColor={'#02222B'}
                strokeWidth={2}
                width="18px"
              />

              <p>There are no grid meters to display.</p>
            </div>
          )}
        </>
      ) : (
        <EnergyUtilityMeterDetail
          currentCampusData={currentCampusData}
          currentCampusId={currentCampusId}
          currentBuildingId={currentBuildingId}
          currentZoneId={null}
          currentGXId={currentGXId}
          hasSingleGX={hasSingleGX}
          currentGXData={currentGXData}
          onBuildingChange={onBuildingChange}
          onGXChange={onGXChange}
          onZoneChange={onZoneChange}
          activePage={activePage}
          showMobile={showMobile}
        />
      )}
    </EnergySection>
  );
};

const EnergySection = styled.section`
  height: 100vh;
  overflow: auto;

  .energy-empty-state {
    align-items: center;
    display: flex;
    gap: 12px;
    justify-content: center;
    padding: 26px 24px 24px;
  }

  .meter-row {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 24px;

    .meter-name-container {
      align-items: center;
      display: flex;
      justify-content: space-between;
      margin: 0 auto 0 0;
      padding: 8px 0 0;
      width: 100%;

      .meter-name {
        color: #02222b;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        text-align: left;
      }

      // .meter-button {
      //     background: #02222B;
      //     border-radius: 8px;
      //     color: white;
      //     cursor: pointer;
      //     font-size: 14px;
      //     font-weight: 600;
      //     padding: 8px 0;
      //     text-align: center;
      //     transition: ease-in all 150ms;

      //     width: 150px;

      //     &:hover {
      //         opacity: 0.7;
      //         transition: ease-in all 150ms;
      //     }
      // }
    }

    .meter-container {
      align-items: center;
      background: white;
      border-radius: 8px;
      box-shadow: 0px 2px 6px #02222b14;
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      padding: 40px;
      width: calc(100% - 80px);

      &:last-of-type {
        border-bottom: none;
        margin-bottom: 0;
      }

      /*MOBILE*/
      &.mobile {
        flex-flow: column;
        justify-content: space-between;
        padding: 24px;
        width: calc(100% - 48px);

        .kiosk-container hr {
          width: calc(100% - 57px);
        }
      }
    }
  }
`;

const mapStateToProps = (state) => {
  return {
    campuses: state.campuses,
    currentCampusId: state.currentCampusId,
    currentGXId: state.currentGXId,
    currentCampusData: state.currentCampusData,
    currentGXData: state.currentGXData,
  };
};

// used by parent class AuthenticatedComponent
const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentGX: (gxId) => {
      dispatch(setCurrentGX(gxId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(Energy));
